import { ROAD } from '../constants';

export const mapy = {
  2: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.NONE, ROAD.HILL.NONE],
  3: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.NONE, ROAD.HILL.NONE],

  //  CURVES

  // functions 10-19
  // flat left
  10: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, -ROAD.CURVE.EASY, ROAD.HILL.NONE],
  11: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, -ROAD.CURVE.MEDIUM, ROAD.HILL.NONE],
  12: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, -ROAD.CURVE.HARD, ROAD.HILL.NONE],

  13: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, -ROAD.CURVE.EASY, ROAD.HILL.NONE],
  14: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, -ROAD.CURVE.MEDIUM, ROAD.HILL.NONE],
  15: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, -ROAD.CURVE.HARD, ROAD.HILL.NONE],

  16: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, -ROAD.CURVE.EASY, ROAD.HILL.NONE],
  // 17: [ROAD.LENGTH.SHORT, ROAD.LENGTH.LONG, ROAD.LENGTH.SHORT, -ROAD.CURVE.EASY, ROAD.HILL.NONE],
  17: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, -ROAD.CURVE.HARD, ROAD.HILL.NONE],
  18: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, -ROAD.CURVE.HARD, ROAD.HILL.NONE],
  // 18: [ROAD.LENGTH.LONG, ROAD.LENGTH.SHORT, ROAD.LENGTH.LONG, -ROAD.CURVE.HARD, ROAD.HILL.NONE],

  19: [ROAD.LENGTH.LONG, 1.3 * ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, -1.3 * ROAD.CURVE.HARD, ROAD.HILL.NONE],

  // flat right
  20: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.EASY, ROAD.HILL.NONE],
  21: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.MEDIUM, ROAD.HILL.NONE],
  22: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.HARD, ROAD.HILL.NONE],

  23: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.EASY, ROAD.HILL.NONE],
  24: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.MEDIUM, ROAD.HILL.NONE],
  25: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.HARD, ROAD.HILL.NONE],

  26: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.EASY, ROAD.HILL.NONE],
  27: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.HARD, ROAD.HILL.NONE],
  28: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.HARD, ROAD.HILL.NONE],

  29: [ROAD.LENGTH.LONG, 1.3 * ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, -1.3 * ROAD.CURVE.HARD, ROAD.HILL.NONE],

  // uphill left
  30: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, -ROAD.CURVE.EASY, ROAD.HILL.LOW],
  31: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, -ROAD.CURVE.MEDIUM, ROAD.HILL.MEDIUM],
  32: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, -ROAD.CURVE.HARD, ROAD.HILL.HIGH],

  33: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, -ROAD.CURVE.EASY, ROAD.HILL.LOW],
  34: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, -ROAD.CURVE.MEDIUM, ROAD.HILL.MEDIUM],
  35: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, -ROAD.CURVE.HARD, ROAD.HILL.HIGH],

  36: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, -ROAD.CURVE.EASY, ROAD.HILL.LOW],
  37: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, -ROAD.CURVE.HARD, ROAD.HILL.MEDIUM],
  38: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, -ROAD.CURVE.HARD, ROAD.HILL.HIGH],

  39: [ROAD.LENGTH.LONG, 1.5 * ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.HARD, 1, 7 * ROAD.HILL.HIGH],

  // uphill right
  40: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.EASY, ROAD.HILL.LOW],
  41: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.MEDIUM, ROAD.HILL.MEDIUM],
  42: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.HARD, ROAD.HILL.HIGH],

  43: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.EASY, ROAD.HILL.LOW],
  44: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.MEDIUM, ROAD.HILL.MEDIUM],
  45: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.HARD, ROAD.HILL.HIGH],

  46: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.EASY, ROAD.HILL.LOW],
  47: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.HARD, ROAD.HILL.MEDIUM],
  48: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.HARD, ROAD.HILL.HIGH],

  49: [ROAD.LENGTH.LONG, 1.5 * ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.HARD, 1, 7 * ROAD.HILL.HIGH],

  // downhill left
  50: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, -ROAD.CURVE.EASY, -ROAD.HILL.LOW],
  51: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, -ROAD.CURVE.MEDIUM, -ROAD.HILL.MEDIUM],
  52: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, -ROAD.CURVE.HARD, -ROAD.HILL.HIGH],

  53: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, -ROAD.CURVE.EASY, -ROAD.HILL.LOW],
  54: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, -ROAD.CURVE.MEDIUM, -ROAD.HILL.MEDIUM],
  55: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, -ROAD.CURVE.HARD, -ROAD.HILL.HIGH],

  56: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, -ROAD.CURVE.EASY, -ROAD.HILL.LOW],
  57: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, -ROAD.CURVE.HARD, -ROAD.HILL.MEDIUM],
  58: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, -ROAD.CURVE.HARD, -ROAD.HILL.HIGH],

  59: [ROAD.LENGTH.LONG, 1.5 * ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.HARD, -1, 7 * ROAD.HILL.HIGH],

  // downhill right
  60: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.EASY, -ROAD.HILL.LOW],
  61: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.MEDIUM, -ROAD.HILL.MEDIUM],
  62: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.HARD, -ROAD.HILL.HIGH],

  63: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.EASY, -ROAD.HILL.LOW],
  64: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.MEDIUM, -ROAD.HILL.MEDIUM],
  65: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.HARD, -ROAD.HILL.HIGH],

  66: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.EASY, -ROAD.HILL.LOW],
  67: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.HARD, -ROAD.HILL.MEDIUM],
  68: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.HARD, -ROAD.HILL.HIGH],

  69: [ROAD.LENGTH.LONG, 1.5 * ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.HARD, -1, 7 * ROAD.HILL.HIGH],

  // STRAIGHT
  //uphill

  70: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.NONE, ROAD.HILL.LOW],
  71: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.NONE, ROAD.HILL.MEDIUM],
  72: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.NONE, ROAD.HILL.HIGH],

  73: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.NONE, ROAD.HILL.LOW],
  74: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.NONE, ROAD.HILL.MEDIUM],
  75: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.NONE, ROAD.HILL.HIGH],

  76: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.NONE, ROAD.HILL.LOW],
  77: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.NONE, ROAD.HILL.MEDIUM],
  78: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.NONE, ROAD.HILL.HIGH],

  //harder uphill

  80: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.NONE, 0.5 * ROAD.HILL.LOW],
  81: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.NONE, 0.5 * ROAD.HILL.MEDIUM],
  82: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.NONE, 0.5 * ROAD.HILL.HIGH],

  83: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.NONE, 0.5 * ROAD.HILL.LOW],
  84: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.NONE, 0.5 * ROAD.HILL.MEDIUM],
  85: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.NONE, 0.5 * ROAD.HILL.HIGH],

  86: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.NONE, 0.5 * ROAD.HILL.LOW],
  87: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.NONE, 0.5 * ROAD.HILL.MEDIUM],
  88: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.NONE, 0.5 * ROAD.HILL.HIGH],

  // downhill
  90: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.NONE, -ROAD.HILL.LOW],
  91: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.NONE, -ROAD.HILL.MEDIUM],
  92: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.NONE, -ROAD.HILL.HIGH],

  93: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.NONE, -ROAD.HILL.LOW],
  94: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.NONE, -ROAD.HILL.MEDIUM],
  95: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.NONE, -ROAD.HILL.HIGH],

  96: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.NONE, -ROAD.HILL.LOW],
  97: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.NONE, -ROAD.HILL.MEDIUM],
  98: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.NONE, -ROAD.HILL.HIGH],

  //harder downhill

  100: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.NONE, 0.5 * -ROAD.HILL.LOW],
  101: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.NONE, 0.5 * -ROAD.HILL.MEDIUM],
  102: [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.NONE, 0.5 * -ROAD.HILL.HIGH],

  103: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.NONE, 0.5 * -ROAD.HILL.LOW],
  104: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.NONE, 0.5 * -ROAD.HILL.MEDIUM],
  105: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.NONE, 0.5 * -ROAD.HILL.HIGH],

  106: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.NONE, 0.5 * -ROAD.HILL.LOW],
  107: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.NONE, 0.5 * -ROAD.HILL.MEDIUM],
  108: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.NONE, 0.5 * -ROAD.HILL.HIGH],

  // ends
  // 100 : []
  // first: short/medium/long
  // second: short/medium/long
  // third: short/medium/long
  // curve: easy/medium/hard/ -easy/ -medium/ -hard
  // default;
  // CURVE: { NONE: 0, EASY: 3, MEDIUM: 4, HARD: 6 },

  200: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, -ROAD.CURVE.EASY / 2, -ROAD.HILL.LOW],
  201: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, -ROAD.CURVE.MEDIUM / 2, -ROAD.HILL.MEDIUM],
  202: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, -ROAD.CURVE.HARD / 2, -ROAD.HILL.HIGH],

  203: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, -ROAD.CURVE.EASY / 2, -ROAD.HILL.LOW],
  204: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, -ROAD.CURVE.MEDIUM / 2, -ROAD.HILL.MEDIUM],
  205: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, -ROAD.CURVE.HARD / 2, -ROAD.HILL.HIGH],

  206: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, -ROAD.CURVE.EASY / 2, -ROAD.HILL.LOW],
  207: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, -ROAD.CURVE.HARD / 2, -ROAD.HILL.MEDIUM],
  208: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, -ROAD.CURVE.HARD / 2, -ROAD.HILL.HIGH],

  210: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.EASY / 2, -ROAD.HILL.LOW],
  211: [ROAD.LENGTH.LONG, ROAD.LENGTH.SHORT, ROAD.LENGTH.LONG, ROAD.CURVE.MEDIUM / 2, -ROAD.HILL.MEDIUM],
  212: [ROAD.LENGTH.LONG, ROAD.LENGTH.SHORT, ROAD.LENGTH.LONG, ROAD.CURVE.HARD / 2, -ROAD.HILL.HIGH],

  213: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.EASY / 2, -ROAD.HILL.LOW],
  214: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.MEDIUM / 2, -ROAD.HILL.MEDIUM],
  215: [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.CURVE.HARD / 2, -ROAD.HILL.HIGH],

  216: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.EASY / 2, -ROAD.HILL.LOW],
  217: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.HARD / 2, -ROAD.HILL.MEDIUM],
  218: [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.CURVE.HARD / 2, -ROAD.HILL.HIGH],
};
